export class FilterCostsPerEmployeeCatalog{
    description!: string;
}